export default {
  title: 'Servidores',

  titles: {
    one: 'Servidor',
    create: 'Crear servidor',
    update: 'Actualizar servidor',
    remove: 'Eliminar servidor'
  },

  labels: {
    title: 'Nombre',
    host: 'Host',
    port: 'Puerto',
    processor: 'Procesador',
    search: 'Buscar'
  },

  contents: {
    confirm: {
      remove: 'Confirme la eliminación del servidor.'
    }
  },

  hints: {
    notFound: 'No se encontraron servidores.',
    host: 'Dirección del servidor, por ejemplo example.com. El par dirección y puerto debe ser único',
    port: 'Puerto de 0 a 64000, por ejemplo 8080',
    other: 'Otro'
  },

  tooltips: {
    favorites: 'Marcar servidor como favorito',
    isActive: 'Servidor activo'
  },

  snackbars: {
    created: 'Servidor creado con éxito',
    updated: 'Servidor actualizado con éxito',
    removed: 'Servidor eliminado con éxito'
  }
}
